import type { BoxProps } from '@shopify/polaris';

import { useTranslation } from 'react-i18next';
import { Box, Text } from '@shopify/polaris';

interface NoDataProps {
  boxProps?: BoxProps;
}
export const NoData: React.FC<NoDataProps> = ({ boxProps }) => {
  const { t } = useTranslation();
  return (
    <Box padding={'300'} minHeight="100px" {...boxProps}>
      <Text as="p">{t('No options found.')}</Text>
    </Box>
  );
};
